import React, { ReactElement } from 'react';

import { Col, Divider, Layout, Row, TypographyText } from '@components/atoms';
import { NOT_FOUND_ERROR_COMMENT, NOT_FOUND_ERROR_TITLE } from '@constants/text';

function NotFoundError(): ReactElement {
  return (
    <Layout>
      <Divider margin={11} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <img alt="cheerupImg" src={`${process.env.PUBLIC_URL}/img/notFound4x.webp`} width="172px" />
        </Col>
      </Row>
      <Divider margin={3} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{NOT_FOUND_ERROR_TITLE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={3} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{NOT_FOUND_ERROR_COMMENT}</TypographyText>
        </Col>
      </Row>
    </Layout>
  );
}

export default NotFoundError;
